module.exports = __webpack_public_path__ + "img/test.a36ca9c9.png";